import PluginManager from '@modifi/plugin-manager'

import countriesReducer from './store'

if (PluginManager.isRegistered('custom-countries') === false) {
  PluginManager.registerPlugin('custom-countries')
  PluginManager.addReducer('custom-countries', countriesReducer)
}

export {
  selectAll,
  selectNameByAlpha2,
  aEnsureCountries,
  selectIsLoaded,
  selectByAlpha2,
} from './store'
